import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Radio, Select, SelectProps } from "@mui/material"

interface IProps extends Omit<SelectProps, "onChange" | "value"> { // Extende de SelectProps, omitindo props conflituosas
    label: string;
    options: {
        value: any;
        label: string;
    }[];
    useSelect?: boolean;
    value?: any;
    onSelect?: (newValue: any) => void;
    helperText?: string,
}
export const SelectComponent = ({
    label,
    options,
    useSelect,
    onSelect,
    value,
    helperText,
    ...rest
}: IProps) => {
    return (
        <FormControl>
            <InputLabel id={`${label.replaceAll(" ", "-")}-label`}>{label}</InputLabel>
            <Select
                labelId={`${label.replaceAll(" ", "-")}-label`}
                id={`${label.replaceAll(" ", "-")}-id`}
                label={label}
                value={value}
                onChange={(e) => onSelect && onSelect(e.target.value)}
                renderValue={(selected) => options.find((item) => item.value === selected)?.label}
                {...rest}
            >
                {useSelect && <MenuItem value={"none"} disabled>
                    <Radio checked={value === "none"} />
                    <ListItemText primary={"Selecione . . ."} />
                </MenuItem>}
                {options.map((item, index) => {
                    return (
                        <MenuItem key={`${label.replaceAll(" ", "-")}-option-${index}`} value={item.value}>
                            <Radio checked={value === item.value} />
                            <ListItemText primary={item.label} />
                        </MenuItem>
                    )
                })}

            </Select>
            <FormHelperText>{helperText || ""}</FormHelperText>
        </FormControl>
    )
}